import React, { useEffect, useRef, useState } from "react";
import history from "utils/history";
// import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import login_lock from "images/login_lock.png";
import { Field, reduxForm } from "redux-form";
import { Modal } from "react-responsive-modal";
import ResetPassword from "containers/ResetPassword/index";
import loginImage from "../../images/loginimage.jpg";
import GTLOGO from "../../images/logo_dark.png";
import gtaxpro_name_image from "../../images/gtaxpro_name_image.svg";
import InputField from "../../components/FormComponents/InputField";
import PrimaryButton from "../../components/FormComponents/PrimaryButton";
import PasswordValidationField from "../../components/FormComponents/PasswordValidationField";
import overlayImg from "../../images/overlayImg.png";
import styles from "./signIn.module.css";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import CachedIcon from "@material-ui/icons/Cached";
import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from "utils/msalConfig";
import { Config } from "../../Config";
import axios from "axios";
import msLogo from "../../images/msLogo.png";
import { saveLocalStorage, getToken, parseJwt } from "components/Helper/Helper";
import { toast } from "react-toastify";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
function Copyright() {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      style={{ color: "white" }}
    >
      {"Copyright © "}
      <Link color="inherit">GTaxPro</Link> {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    borderRadius: "13px",
  },
  multilineColor: {
    color: "black",
  },
}));
const renderTextField = ({
  input,
  label,
  type,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    margin="normal"
    required
    variant="filled"
    autoComplete="off"
     label={label}
    type={type}
    autoFocus
    size="small"
    errorText={touched && error}
    {...input}
    {...custom}
    InputProps={{
      style: {
        backgroundColor: "rgb(232, 240, 254)", // Ensures the background color is applied
      },
    }}
    InputLabelProps={{
      style: {
        fontSize: "12px",
        paddingTop: "0px",
        fontWeight: "600",
        color: "rgb(92 66 127)",
      },
    }}
  />
);

const SignIn = (props) => {
  const msalInstance = new PublicClientApplication(msalConfig);
  // const history = useHistory();

  const classes = useStyles();
  const { handleSubmit, onVerifyResetPasswordEmail ,isShowResetPassModal, setIsShowResetPassModal} = props;
  const ref = useRef(null);
  const [currentStep, setCurrentStep] = useState(1); // 1 for email, 2 for password/captcha
  const [userEmail, setUserEmail] = useState("");
  // let [isShowResetPassModal, setIsShowResetPassModal] = useState(false);
  useEffect(() => {
    if (currentStep === 2) {
      loadCaptchaEnginge(6,'#ADD8D8','#00008B');
    }
  }, [currentStep]);
  let [resetErrMsg, setResetErrMsg] = useState("");

  let resetPassWordModalHandler = (email) => {
    onVerifyResetPasswordEmail(email)
      .then(() => {
        setIsShowResetPassModal(false);
        setResetErrMsg("");
      })
      .catch((err) => {
        setResetErrMsg(err);
      });
  };

  let onCloseResetPasswordModalHandler = () => {
    setResetErrMsg("");
    setIsShowResetPassModal(false);
  };

  const handleContinue = (values) => {
    if (values && values.email) {
      setUserEmail(values.email);
      setCurrentStep(2);
    }
  };

  const handleBackToEmail = () => {
    setCurrentStep(1);
    setUserEmail("");
  };

  const handlePasswordChange = (passwordValue, validationResults, strength) => {
    // Handle password validation results if needed
    // This can be used for additional logic like enabling/disabling submit button
  };

  const callMsalFunction = async () => {
    try {
      console.log("Login attempt started");
      // dispatch(startLoading());

      // Initialize MSAL instance
      await msalInstance.initialize();

      // Handle redirect promise
      const redirectResponse = await msalInstance.handleRedirectPromise();
      console.log("Redirect Response:", redirectResponse);

      // Perform login via popup
      const loginResponse = await msalInstance.loginPopup({ scopes: [] });
      console.log("Login Response:", loginResponse);

      // Set active account and save user details
      const activeAccount = loginResponse.account;
      msalInstance.setActiveAccount(activeAccount);
      localStorage.setItem("username", activeAccount.username);
      localStorage.setItem("user", JSON.stringify(activeAccount));

      // dispatch(login());
      // dispatch(addDetails(activeAccount.name));

      // Acquire token silently
      const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: [process.env.REACT_APP_CUSTOMAPIURL], // Adjust scope based on your API
      });

      console.log("Token Response:", tokenResponse);
      // localStorage.setItem("accessToken", tokenResponse.accessToken);

      // Fetch and save user role and menu details
      const accessToken = tokenResponse.accessToken;
      if (accessToken) {
        // console.log("accessToken:", accessToken);
        // localStorage.setItem("accessToken", accessToken);
        // localStorage.setItem("loginDetails", accessToken);
        let userExistsResponse = await axios({
          method: "post",
          data: {},
          url: `${Config.url}user/ssoAuthenticate`,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log("userExistsResponse", userExistsResponse);
        if (userExistsResponse.data.token) {
          let tokenData = await parseJwt(userExistsResponse.data.token);
          const userId = {
            user_id: userExistsResponse.data.user_id,
          };
          const loginDetails = {
            token: userExistsResponse.data.token,
          };

          const UserEmail = {
            email: userExistsResponse.data.email,
          };
          const userInfo = {
            email: `${tokenData?.first_name
              ?.substring(0, 1)
              .toUpperCase()}${tokenData?.last_name
              ?.substring(0, 1)
              .toUpperCase()}`,
          };
          saveLocalStorage("loginDetails", loginDetails);
          saveLocalStorage("userInfo", userInfo);
          saveLocalStorage("userEmail", UserEmail);
          saveLocalStorage("role", tokenData.role);
          saveLocalStorage("user_id", userId);
          props.history.push("/landing");
        } else {
          toast.error("User not found", {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }


      }
    } catch (error) {
      // Handle errors and stop loading
      console.log("Error during login:", error);
      // dispatch(stopLoading());
    } finally {
      // Ensure loading state is cleared
      // dispatch(stopLoading());
    }
  };

  return (
    <>
      {/* <Grid
        container
        style={{
          backgroundColor: "#4f2d7f", // "rgb(79, 45, 127)c",
          padding: "5vw 10vw",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "1rem",
            width: "40%",
          }}
        >
          <Grid item>
            <Grid container spacing={2} style={{ display: "grid" }}>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  //   padding: "1rem",
                  marginTop: "20px",
                  marginBottom: "5px",
                }}
              >
                <img style={{ width: "50%" }} src={GTLOGO} alt="logo" />
              </Grid>
              <div className="subHeading">GTaxPro</div>
              <form onSubmit={handleSubmit}>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <Field
                    name="email"
                    component={renderTextField}
                    label="Email Address"
                    type="email"
                    variant="outlined"
                    style={{
                      width: "60%",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",

                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <Field
                    name="password"
                    type="password"
                    component={renderTextField}
                    label="Password"
                    variant="outlined"
                    style={{
                      width: "60%",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <LoadCanvasTemplateNoReload />
                    <div
                      onClick={() => {
                        loadCaptchaEnginge(6);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <CachedIcon />
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",

                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <TextField
                    label="Enter Captcha Value *"
                    autoComplete="off"
                    id="user_captcha_input"
                    name="user_captcha_input"
                    type="text"
                    size="small"
                    variant="outlined"
                    style={{
                      width: "60%",
                    }}
                    InputLabelProps={{
                      style: {
                        color: "#CBC4BC",
                        fontFamily: "GT-Walsheim-medium",
                        fontSize: "16px",
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",

                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    style={{
                      backgroundColor: "#4F2D7F",
                      color: "white",
                      outline: "none",
                      width: " 60%",
                    }}
                  >
                    Sign In
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    // padding: "1rem",
                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <a
                    style={{
                      color: "blue",
                      cursor: "pointer",
                      marginBottom: "10px",
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "12px",
                    }}
                    type="button"
                    onClick={() => {
                      setResetErrMsg("");

                      setIsShowResetPassModal(true);
                    }}
                  >
                    Forgot Password?{" "}
                  </a>{" "}
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",

                    fontWeight: "500",
                    color: "gray",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      whiteSpace: "nowrap",
                      fontFamily: "Gt-Walsheim-medium",
                      fontSize: "11px",
                    }}
                  >
                    In case of any queries, please write to{" "}
                    <a href={"mailto:" + "gtaxpro@in.gt.com"}>
                      gtaxpro@in.gt.com
                    </a>
                  </p>
                </Grid>
              </form>
              {isShowResetPassModal && (
                <ResetPassword
                  resetPassWordModalHandler={resetPassWordModalHandler}
                  onCloseResetPasswordModalHandler={
                    onCloseResetPasswordModalHandler
                  }
                  errMsg={resetErrMsg}
                />
              )}
            </Grid>
          </Grid>
        </div>
      </Grid> */}
      <div className={styles.loginPage}>
        <div className={styles.imageWrapper}>
          <div className={styles.imageContainer}>
            <img src={overlayImg} alt="Image" />
          </div>
        </div>
        <form
          onSubmit={currentStep === 1 ? handleSubmit(handleContinue) : handleSubmit}
          style={{
            paddingLeft: "3em",
            paddingTop: "1em",
            paddingBottom: "1em",
          }}
        >
          <div className={styles.loginBoxWrapper}>
            <div className={styles.loginFormContainer}>
              <div className={styles.logoImg}>
                {/* <img src={GTLOGO} alt="logo" /> */}
                <img src={gtaxpro_name_image} alt="GT logo" />
              </div>
              <div className={styles.subHeading}>Welcome, Login to continue</div>
              <div className={styles.formControl}>
                <div style={{ width: "90%" }}>
                  {/* <div className={styles.formHeading}>
                    {currentStep === 1 ? "" : "Login"}
                  </div> */}

                  {/* Step 1: Email Input */}
                  {currentStep === 1 && (
                    <>
                      <div className={styles.inputField}>
                        <Field
                          className="loginInput"
                          name="email"
                          component={renderTextField}
                          label="Email"
                          type="email"
                          variant="outlined"
                          style={{
                            width: "100%",
                            fontSize: "12px",
                          }}
                        />
                      </div>
                      <div className={styles.inputField}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          style={{
                            backgroundColor: "#4F2D7F",
                            textTransform: 'capitalize',
                            color: "white",
                            outline: "none",
                            width: "100%",
                            marginTop: "10px",
                          }}
                        >
                         
                          Continue
                           <ArrowRightAltIcon />
                        </Button>
                      </div>
                    </>
                  )}

                  {/* Step 2: Password and Captcha */}
                  {currentStep === 2 && (
                    <>
                      <div className={styles.inputField}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                          <Button
                            onClick={handleBackToEmail}
                            style={{
                              minWidth: '30px',
                              padding: '5px',
                              marginRight: '10px',
                              color: '#4F2D7F'
                            }}
                          >
                            {/* ← */}
                            <KeyboardBackspaceIcon />
                          </Button>
                          <span style={{ 
                            fontSize: '14px', 
                            color: '#4F2D7F',
                            backgroundColor: '#e8f0fe',
                            padding: '6px 12px',
                            borderRadius: '16px',
                            border: '1px solid #d0d7de',
                            display: 'inline-flex',
                            alignItems: 'center',
                            maxWidth: '200px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            <AccountCircleIcon style={{ marginRight: '6px', fontSize: '18px' }}/>
                            {/* <AccountCircleOutlinedIcon /> */}
                            <span style={{ 
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                              {userEmail}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className={styles.inputField}>
                        {/* <Field
                          name="password"
                          component={PasswordValidationField}
                          label="Password"
                          variant="outlined"
                          style={{
                            width: "100%",
                          }}
                          onPasswordChange={handlePasswordChange}
                        /> */}
                        <Field
                      name="password"
                      type="password"
                      component={renderTextField}
                      label="Password"
                      variant="outlined"
                      style={{
                        width: "100%",
                      }}
                    />
                      </div>
                      <div className={styles.additionalButtons}>
                        <div>
                          {/* <Checkbox
                            id="staySignIn"
                            size="small"
                            style={{ padding: "0px 3px 1px 0px" }}
                            sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                          /> */}
                          {/* <label for="staySignIn">Stay Sign In</label> */}
                        </div>
                        <div
                          style={{ cursor: "pointer", paddingTop: "2px" }}
                          onClick={() => {
                            setResetErrMsg("");
                            setIsShowResetPassModal(true);
                          }}
                        >
                          Forgot Password
                        </div>
                      </div>
                      <div className={styles.captchaContainer}>
                        <LoadCanvasTemplateNoReload />
                        <div
                          onClick={() => {
                            loadCaptchaEnginge(6,'#ADD8D8','#00008B');
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <CachedIcon />
                        </div>
                      </div>
                      <div className={styles.inputField}>
                        <InputField
                          label="Enter Captcha"
                          id="user_captcha_input"
                          name="user_captcha_input"
                          size="small"
                          variant="outlined"
                          color="primary"
                          fullWidth
                          type="text"
                          inputStyles={{ fontSize: "12px", borderRadius: "5px" }}
                          InputLabelProps={{
                            style: {
                              fontSize: "12px",
                              paddingTop: "0px",
                              fontWeight: "600",
                              color: "rgb(92 66 127)",
                            },
                          }}
                        />
                      </div>
                      <div className={styles.inputField}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          style={{
                            backgroundColor: "#4F2D7F",
                            textTransform: 'capitalize',
                            color: "white",
                            outline: "none",
                            width: "100%",
                            marginTop: "10px",
                          }}
                        >
                          Login
                        </Button>
                      </div>
                    </>
                  )}

                  <div
                    style={{ fontSize: "0.8rem", marginTop: "10px" }}
                    className={styles.createAccount}
                  >
                    OR
                  </div>
                  <Button
                    className="loginBtn"
                    style={{
                      background: "#725799",
                      textTransform: "capitalize",
                      width: "100%",
                      color: "#fff",
                      margin: "10px 0px",
                    }}
                    variant="contained"
                    onClick={() => callMsalFunction()}
                  >
                    <img
                      src={msLogo}
                      style={{ width: "20px", marginRight: "5px" }}
                    />{" "}
                    Login With Microsoft
                  </Button>
                  <div className={styles.createAccount}>
                    For any queries, please contact &nbsp;
                    <a
                      style={{ color: "#4F2D7F" }}
                      href={"mailto:" + "gtaxpro@in.gt.com"}
                    >
                      gtaxpro@in.gt.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {isShowResetPassModal && (
              <ResetPassword
                resetPassWordModalHandler={resetPassWordModalHandler}
                onCloseResetPasswordModalHandler={
                  onCloseResetPasswordModalHandler
                }
                errMsg={resetErrMsg}
              />
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default reduxForm({
  form: "SignIn", // a unique identifier for this form
})(SignIn);
// export default SignIn
